export default "__VITE_ASSET__Bw0l7xfC__"